import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangContext } from "./lib/i18n";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("mareia_lang") || (navigator.language?.startsWith("fr") ? "fr" : "fr"));
  useEffect(() => {
    localStorage.setItem("mareia_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </LangContext.Provider>
  );
}

export default App;
